import { render } from "./DbaCpfCnpjFieldContainer.vue?vue&type=template&id=023ddc84"
import script from "./DbaCpfCnpjFieldContainer.vue?vue&type=script&lang=js"
export * from "./DbaCpfCnpjFieldContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__